import { render } from "./ConcertsSection.vue?vue&type=template&id=a864f2be&scoped=true"
import script from "./ConcertsSection.vue?vue&type=script&lang=js"
export * from "./ConcertsSection.vue?vue&type=script&lang=js"

import "./ConcertsSection.vue?vue&type=style&index=0&id=a864f2be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a864f2be"

export default script